export const LogoMark = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M32 58C32 58 6 42.5 6 23.5C6 13.6 13.9 6 23.5 6C27.6 6 31 8.2 32 11C33 8.2 36.4 6 40.5 6C50.1 6 58 13.6 58 23.5C58 42.5 32 58 32 58Z"
      fill="#E07A5F"
    />
    <path
      d="M14 31H24L28 21L34 41L38 31H50"
      stroke="#FBF9F6"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BrandLockup = ({ dark = false, size = 26 }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-lockup">
    <LogoMark size={size} />
    <span
      className={`font-extrabold tracking-[0.18em] ${dark ? "text-sand" : "text-ink"}`}
      style={{ fontSize: size * 0.72 }}
    >
      STETH
    </span>
  </span>
);
